// Action Types for auth
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";

export const LOGOUT_REQUEST = "LOGOUT_REQUEST";

// Profile Action Types

export const PROFILE_RESET_REQUEST = "PROFILE_RESET_REQUEST";
